import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Loader from '../../../Components/Loader'
import noneImage from '../../../assets/none-png-2.png'
import { Helmet } from 'react-helmet'
import Error from '../../../Components/Error'
import Cast from '../../../Components/Cast'
import CastProfileImages from '../../../Components/CastProfileImages'

const Container = styled.div`
    height: calc(100vh - 50px);
    width: 100%;
    position: relative;
    padding:70px;
    
    @media screen and (max-width:768px) {
        padding:0;
        overflow-y:auto;
        height:100%;
    }
`
const Backdrop = styled.div`
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:calc(100vh - 50px);
    background-image:url(${props => props.imgBg});
    background-position:center center;
    background-size:cover;
    filter:blur(3px);
    opacity:0.5;
    @media screen and (max-width:768px) {
        width:100%;
        margin:auto;
        z-index:-1;
        top:0;
        left:0;
        position:fixed;
        height:calc(100vh);
        z-index:-1;
        opacity:0.3
    }
`

const Content = styled.div`
    display:flex;
    width: 100%;
    position:relative;
    z-index:1;
    height:100%;
    border-radius:5px;
    @media screen and (max-width:768px) {
        flex-direction:column;
        position: relative;
        width:100%;
    }
`

const Cover = styled.div`
    border-radius:5px;
    min-width:30%;
    margin-right:20px;
    background-image:url(${props => props.imgBg});
    background-position:center center;
    background-size:cover;
    height:100%;
    z-index:0;
    @media screen and (max-width:768px) {
        display:none;
    }
`

const Data = styled.div`
    width:65%;
    height:100%;
    overflow: auto;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
            background:rgba(0,0,0,0.1)
        }
        &::-webkit-scrollbar-thumb {
            background: rgba(255,255,255,0.2);
    }
        &::-webkit-scrollbar-thumb:hover {
            background: rgba(255,255,255,0.5);
    }
    margin-left:10px;
    @media screen and (max-width:768px) {
        padding-top:5%;
        width:90%;
        margin-left:0;
        margin:0 auto;
        overflow:unset;
        order:1;
    }
`

const Title = styled.h3`
    font-size:32px;
    @media screen and (max-width:768px) {
       font-size:23px;
       color:yellow;
    }
`

const ItemContainer = styled.div`
    margin:20px 0;
    @media screen and (max-width:768px) {
        width:90%;
       margin:15px 0 10px;
       overflow:hidden;
       text-overflow:ellipsis;
       white-space:nowrap;
    }
`

const Item = styled.span`

`

const Divider = styled.span`
    margin: 0 10px;
    @media screen and (max-width:768px) {
       margin:0 5px;
    }
`

const Overview = styled.div`
    font-size:18px;
    padding:5px 5px 0px 0px;
    opacity:0.7;
    line-height:1.5;
    p{
        color:#f5c518;
    }
    @media screen and (max-width:768px) {
       width:100%;
       font-size:14px;
       div{
        width:100%;
    }
    }

`
const IMDb = styled.span`
    font-size:18px;
    font-weight:700;
    margin-left:10px;
    padding:0 6px;
    text-align:center;
    vertical-align:center;
    border-radius:4px;
    color:black;
    background:#F5C518;
    @media screen and (max-width:768px){
        font-size:16px;
    }
`
const Foot = styled.div`
    display:none;
    @media screen and (max-width:768px) {
        display:block;
       height:20px;
    }
`
const CastContainer = styled.div`
    padding:10px 0 0;
    margin:auto;
    
`
const CastPerson
    = ({ loading, error, result }) => {
        return (
            loading ? <Loader /> : error ? <Error data={'No Cast Data'} /> : result &&
                <Container>
                    <Helmet>
                        <title>
                            {result.name && result.name} | Maflix
                    </title>
                    </Helmet>
                    <Backdrop imgBg={result.profile_path && result.profile_path ? `https://image.tmdb.org/t/p/w500${result.profile_path}` : null} />
                    <Content>
                        <Cover imgBg={result.profile_path && result.profile_path ? `https://image.tmdb.org/t/p/original${result.profile_path}` : noneImage} />
                        <Data>
                            <Title>
                                {result.name && result.name}
                                <IMDb>
                                    {result.imdb_id && result.imdb_id ? <a href={`https://www.imdb.com/name/${result.imdb_id}`} rel='noopener noreferrer' target='_blank'>IMDB</a> : 'IMDB'}
                                </IMDb>
                            </Title>
                            <ItemContainer>
                                <Item>{result.birthday && result.birthday.substring(0, 4)}</Item>
                                <Divider>~</Divider>
                                <Item>{result.deathday && result.deathday.substring(0, 4)}</Item>
                                <Divider>▪</Divider>
                                <Item>{result.place_of_birth && result.place_of_birth}</Item>
                                <Divider>▪</Divider>
                                <Item>{result.known_for_department && result.known_for_department}</Item>
                                <Divider>▪</Divider>
                                <Item>{result.gender && result.gender === 1 ? 'Female' : 'Male'}</Item>
                            </ItemContainer>
                            <Overview>
                                <p>Also Known as</p>
                                <div>{result.also_known_as && result.also_known_as.map((i, index) => index === result.also_known_as.length - 1 ? i : `${i} / `)}</div>
                                <br />
                                <p>Biography</p>
                                <div className="bio">
                                    {result.biography && result.biography.length > 0 && result.biography}
                                </div>
                                <p>Images</p>
                            </Overview>
                            <CastContainer>
                                {result.images && result.images.profiles.length > 0 && (
                                    <Cast>{result.images.profiles.map((i, index) => <CastProfileImages key={index} imgUrl={i.file_path} />)}</Cast>
                                )}
                            </CastContainer>
                        </Data>
                    </Content>
                    <Foot></Foot>
                </Container >)
    }

CastPerson
    .propTypes = {
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    result: PropTypes.object
}

export default CastPerson
